export default __webpack_public_path__ + "static/media/thumb_9D.d67ddb0a.png";